import { render, staticRenderFns } from "./EditFarmAltModal.vue?vue&type=template&id=0639ca5c&scoped=true&"
import script from "./EditFarmAltModal.vue?vue&type=script&lang=js&"
export * from "./EditFarmAltModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFarmAltModal.vue?vue&type=style&index=0&id=0639ca5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639ca5c",
  null
  
)

export default component.exports